import { render } from "./ConnectAndPolygonModal.vue?vue&type=template&id=5a36a5b9&scoped=true"
import script from "./ConnectAndPolygonModal.vue?vue&type=script&lang=js"
export * from "./ConnectAndPolygonModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/connectionAndPolygonModal.scss?vue&type=style&index=0&id=5a36a5b9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a36a5b9"]])

export default __exports__